import { ReactNode } from 'react';
import {
  MuiDivider,
  MuiGrid,
  MuiStack,
} from '../../../../../../../../modules/material';
import { getPriceAsNumber } from '../../../../../../helpers/shared/getPriceAsNumber';
import DiscountRow from './DiscountRow';
import Typography from '../../../../../../shared/library/Typography';
import Price from '../../../../../../shared/components/Price';
import { useTranslation } from 'react-i18next';

export interface DiscountsListProps {
  totalPrice: string;
  list: {
    name: string;
    subName?: string;
    price?: string;
  }[];
  vat?: ReactNode;
}

export default function DiscountsList(props: DiscountsListProps) {
  const { t } = useTranslation();
  const { totalPrice, list, vat } = props;

  return (
    <>
      <MuiGrid spacing={2.5} container>
        {list.map((item) => {
          if (!getPriceAsNumber(item.price)) {
            return null;
          }

          return (
            <DiscountRow
              name={<Typography>{item.name}</Typography>}
              subName={
                item.subName && (
                  <Typography variant="smallText" neutralColorIndex={600}>
                    {item.subName}
                  </Typography>
                )
              }
              price={
                <Price variant="body1" neutralColorIndex={900}>
                  {item.price}
                </Price>
              }
              key={item.name}
            />
          );
        })}
      </MuiGrid>

      <MuiDivider sx={{ margin: '10px -12px' }} />

      <DiscountRow
        name={
          <Typography neutralColorIndex={900}>
            {t('site.pricing.products-selection.price-info.total.label')}
          </Typography>
        }
        price={
          <MuiStack>
            <Price variant="h4" component="span" neutralColorIndex={900}>
              {totalPrice}
            </Price>
            {vat}
          </MuiStack>
        }
        alignItems="center"
      />
    </>
  );
}
